module.exports = __webpack_public_path__ + "img/weddings_36_V.5f6cad0e.webp";